export default "__VITE_PUBLIC_ASSET__93f0ef9a__"